import React from 'react';
import { Box, Button, Tooltip, Popover } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useStyles } from './styles';
import ApplicationsTableGlobalFilter from '€components/ApplicationsTableGlobalFilter';
import { ApplicationsTableFilterPopoverProps } from '€lib/types/ApplicationsTableTypes';

export default function ApplicationsTableFilterPopover({
    headerGroups,
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
    setAllFilters,
}: ApplicationsTableFilterPopoverProps) {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <Tooltip title="Filter cases">
                <Button
                    aria-label="filter cases"
                    aria-describedby={id}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                        setAnchorEl(e.currentTarget)
                    }
                    variant="outlined"
                    color="default"
                    className={classes.button}
                    endIcon={<FilterListIcon />}
                >
                    Filter
                </Button>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                }}
            >
                <Box>
                    <ApplicationsTableGlobalFilter
                        preGlobalFilteredRows={preGlobalFilteredRows}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                    />

                    {headerGroups.map(headerGroup => (
                        <div key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <div key={column.id}>
                                    {column.canFilter ? column.render('Filter') : null}
                                </div>
                            ))}
                        </div>
                    ))}
                </Box>
                <Box className={classes.bottomBar}>
                    <Button
                        aria-label="reset filter"
                        onClick={() => setAllFilters([])}
                        variant="outlined"
                        color="default"
                        className={classes.button}
                    >
                        Reset All
                    </Button>
                </Box>
            </Popover>
        </>
    );
}
